import { render, staticRenderFns } from "./ProductBreadcrumb.vue?vue&type=template&id=45fb00be&scoped=true"
import script from "./ProductBreadcrumb.vue?vue&type=script&lang=js"
export * from "./ProductBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./ProductBreadcrumb.vue?vue&type=style&index=0&id=45fb00be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fb00be",
  null
  
)

export default component.exports